import { opaccAjaxPlugin, opaccLocalStoragePlugin } from '../opacc.static.js';

/** @module filter */

/**
 * Funktionalität des Filter-Typ "Select".
 */
export class SelectFilter {

	constructor(item, wrapper, opaccFilterCriterias) {
		this.filterItem = item;
		this.wrapperItem = wrapper;
		this.opaccFilterCriterias = opaccFilterCriterias;
		this.id = this.filterItem.id;
		this.filterType = this.filterItem.dataset.opFiltertype;
		this.searchFilterValue();
	}

	/**
	 *
	 *
	 * @param {*} elem
	 * @returns {*}
	 */
	selectValueByTargetAndSetFilterCriterias(elem) {
		let elementControl = elem.control || this.wrapperItem.querySelector(`#${elem.htmlFor}`);
		return this.selectValue(elementControl);
	}

	/**
	 *
	 *
	 * @param {*} selectedItem
	 */
	selectValue(selectedItem) {
		let groupId = selectedItem.closest('.opc-filter').dataset.opGroupid;
		let filterId = selectedItem.closest('.opc-filter').id;

		switch (this.filterType) {
		case 'B':
		case 'G':
			if (selectedItem.checked == true) {
				selectedItem.checked = false;
				this.opaccFilterCriterias.remove(selectedItem.dataset.opFilterattr, selectedItem.value, true, groupId, filterId);

			} else {
				selectedItem.checked = true;
				this.opaccFilterCriterias.add(selectedItem.dataset.opFilterattr, selectedItem.value, true, groupId, filterId);
			}
			break;
		default:
			selectedItem.checked = !selectedItem.checked;
			if (selectedItem.checked) {
				this.opaccFilterCriterias.change(selectedItem.dataset.opFilterattr, selectedItem.value, true, groupId, filterId);
			} else {
				this.opaccFilterCriterias.remove(selectedItem.dataset.opFilterattr, null, true, groupId, filterId);
			}
			break;
		}
	}

	searchFilterValue() {
		// Liste der Filterwerte durchsuchen
		let list = this.filterItem.querySelector('.select-list');
		if (list)
		{
			if (!this.opaccFilterCriterias.isSelectionFilterAsyncDataload(this.filterItem.dataset.opAsync))
			{
				return;
			}

			let groupId = this.filterItem.dataset.opGroupid;
			if (!groupId)
			{
				groupId = 'cat';
			}

			let filterId = this.filterItem.dataset.opFilterid;
			let cryptedData = this.filterItem.dataset.opCrypt;
			let cryptedExpression = "&crypt=";
			if (cryptedData)
			{
				cryptedExpression += cryptedData;
			}

			let groupIdExpression = "&groupid=";
			if (groupId)
			{
				groupIdExpression += groupId;
			}

			let filterIdExpression = "&filterid=";
			if (filterId)
			{
				filterIdExpression += filterId;
			}

			let queryStringGroupIdFilter = this.getGroupIdFilterValueFromUrl(groupId);
			let url = window.location.protocol;
			url = url.concat("//", window.location.hostname, "/WebPortal/async.aspx?type=filterautocomplete", cryptedExpression, groupIdExpression, filterIdExpression, queryStringGroupIdFilter);
			let selection = window.opaccFilterCriteriasData[this.catGroupId];
			if (selection) {
				data = {
					selection: JSON.stringify(selection)
				};
			}

			// start-loading animation
			this.filterItem.classList.add('is-loading');
			let asynData = this.getAsynData(url);
			asynData.then((result) => {
				if (result) {
					// end-loading animation
					this.filterItem.classList.remove('is-loading');
					const selectorBodyInner = 'div.filter-body-inner';
					let filterBodyInner = this.filterItem.querySelector(selectorBodyInner);
					var parser = new DOMParser();
					var element = parser.parseFromString(result, "text/html");
					if (element.querySelector(selectorBodyInner))
					{
						const selectorBodyReset = 'div.filter-body-reset';
						let filterBodyReset = element.querySelector(selectorBodyReset);
						let filterBodyResetOuterHtml = '';
						if (filterBodyReset)
						{
							filterBodyResetOuterHtml = filterBodyReset.outerHTML;
						}
						filterBodyInner.outerHTML = [element.querySelector(selectorBodyInner).outerHTML, filterBodyResetOuterHtml].join('');
					}
				}
			});
		}
	}

	/**
	 * Filterwert der Gruppen-Id aus der URL lesen.
	 *
	 * @param {string} groupId groupId als String
	 * @returns Variable queryStringGroupIdFilter
	 */
	getGroupIdFilterValueFromUrl(groupId) {
		const urlParams = new URLSearchParams(window.location.search);
		var groupIdFilter = urlParams.get(groupId);
		let queryStringGroupIdFilter = '';
		if (groupIdFilter)
		{
			queryStringGroupIdFilter = `&${groupId}=${groupIdFilter}`;
		}
		else if (`${urlParams}`.length > 0)
		{
			queryStringGroupIdFilter = `&${urlParams}`;
		}

		return queryStringGroupIdFilter;
	}

	/**
	 * Aufruf des asynchronen Requests.
	 *
	 * @param {string} url Ziel-URL als String
	 * @returns Promise zur Weiterverarbeitung der asynchronen Operation
	 */
	async getAsynData(url) {
		return new Promise(resolve => {
			opaccAjaxPlugin.fetchAsynGetJson(url, this.getResultList.bind(this, resolve), this.asyncErrorHandler.bind(this), true );
		});
	}

	/**
	 * Freigabe (resolve) des asynchronen Requests (Promise) zur Weiterverarbeitung des Resultats.
	 *
	 * @param {Function} resolve Funktion um das ausstehende Resultat der Promise freizugeben
	 * @param {Object} response Ergebnisobjekt mit dem Resultat des asynchronen Requests.
	 */
	getResultList(resolve, response) {
		if (response.success) {
			let autocompleteFilterList = response.dataAsHtml;
			resolve(autocompleteFilterList);
		}
	}

	/**
	 * Methode für fehlerhaften Ajax-Request
	 *
	 * @param {DOMException} error Error-Object der asynchronen Operation
	 */
	asyncErrorHandler(error) {
		// eslint-disable-next-line no-console
		console.error('Request failed: ', error.message);
		this.hookAfterAsyncErrorHandler(error);
	}

	/**
	 * Hook um bei fehlerhaftem asynchronen Request weitere Funktionalitäten ausführen zu können.
	 *
	 * @param {DOMException} error Error-Object der asynchronen Operation
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterAsyncErrorHandler(error){}
}